<template>
  <div class="billboards" v-if="billboardList.length">
    <mt-swipe>
      <mt-swipe-item v-for="slider in billboardList" :key="slider.key" >
        <router-link :to="slider.href" class="item-wrap" v-track="{act:'click',data:{id: 350,p:[slider.bannerId]}}">
          <lazy-img :src="slider.imgUrl" alt="slider" height="calc((275 / 750) * 100vw)"></lazy-img>
        </router-link>
      </mt-swipe-item>
    </mt-swipe>
  </div>
</template>>

<script>
  import { Swipe, SwipeItem } from 'mint-ui'
  import { resolveActionPath, webview } from '../../../../util/function'
  import lazyImg from '../../../../components/lazy-img'

  export default {
    props: {
    },
    name: 'billboards',
    data() {
      return {
      }
    },
    mounted(){
    },
    computed: {
      billboardList() {
        let billboardListState = this.$store.state.preorder.billboardList|| []
        return billboardListState.map((item) => {
          return {
            key:item.bannerId+""+new Date().getTime(),
            bannerId: item.bannerId,
            imgUrl: item.imgUrl,
            href: resolveActionPath(item)
          }
        })
      }
    },
    components: {
      [Swipe.name]: Swipe,
      [SwipeItem.name]: SwipeItem,
      'lazy-img': lazyImg
    },
    methods: {
      onClick(url) {
        return webview(url)
      },
    }
  }

</script>
<style lang='less' scoped>
  .billboards {
    height: calc(~'(275 / 750) * 100vw');
    border-radius: 4px;
    box-shadow: 2px 2px 3px #aaaaaa;
    overflow: hidden;
    .item-wrap{
      height: 100%;
      width: 100%;
      display: block;
    }
  }
</style>
